import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * GET resiliente com re-tentativas e backoff exponencial.
 *
 * Motivo: logo após um deploy/redeploy, o backend pode levar alguns segundos
 * para ficar pronto (cold start). Sem retry, a primeira chamada falha e a página
 * mostra "vazio". Com retry, a chamada é repetida automaticamente até o backend
 * responder — o cliente nunca vê a loja sem produtos.
 *
 * Lança erro somente depois de esgotar todas as tentativas.
 */
export async function apiGetWithRetry(path, config = {}, { retries = 6, baseDelay = 700 } = {}) {
  let lastErr;
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      return await axios.get(`${API}${path}`, config);
    } catch (e) {
      lastErr = e;
      if (attempt < retries) {
        const wait = Math.min(baseDelay * Math.pow(1.7, attempt), 6000);
        await new Promise((r) => setTimeout(r, wait));
      }
    }
  }
  throw lastErr;
}
